//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import imgtoast from '../common/imgtoast';
import html2canvas from 'html2canvas';
  export default {
      name: "success",
    data(){
        return{
          code:'',
            img:''
        }
    },
      components:{
          imgtoast
      },
      methods:{
        capture(){
            html2canvas(this.$refs.capture).then((canves)=>{
                this.img=canves.toDataURL();
                this.$vux.toast.text('长按图片保存');
            })
        },
        gostudy(){
          location.href='/dist/#/HomeList?user_key='+this.$cookies.get('token')+'&id='+this.$route.params.data.id;
        }
      },
    created() {
        this.axios.post('/xcx/Order/getCode',{order_id:this.$route.params.orderId}).then(res=>{
        // this.axios.post('/xcx/Order/getCode',{order_id:112}).then(res=>{
          this.code=res.data.data.code;
        })
    }
  }



// WEBPACK FOOTER //
// ./src/components/success/success.vue